import { Modal } from 'antd';
import styled from 'styled-components';
import {
  maxMobile,
  primaryColor, primaryFont, primaryHeadingColor, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import CrossCircle from '../assets/svgIcons/CrossCircle';

type Props = {
  visibleFlag: boolean,
  groupName: string,
  onCancel: () => void,
  onMerge: () => void,
  onSave: () => void,
};

const GroupModalWrapper = styled(Modal)`
  cursor: pointer;
  .ant-modal-footer {
    display: none;
    &.custom-footer {
      display: block;
      padding: 30px 0px 0px 0px !important;
     .copyGroupName {
      display: block;
      text-align: center;
      margin-top: 30px;
      font-weight: ${wMedium};
      font-family: ${primaryFont};
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.8px;
      color: #000000;
      opacity: 0.4;
     }
     button {
      &.ant-btn-default {
        border: 2px solid ${primaryColor};
        &.filled-btn {
          background-color: ${primaryColor};
          color: #fff;
        }
      }
     }
    }
  }
  .ant-modal-content {
    position: relative;
    height: auto;
   .ant-modal-body {
      padding: 110px 50px 16px 50px !important;
      height: 100%;
      @media all and (max-width: ${maxMobile}) {
        padding: 50px 20px 16px 20px !important;
      }
      .borderedButton {
        border-radius: 50px;
        padding: 4px 15px !important;
      }
    }
  }
`;

const GroupNameHeading = styled.h6`
  font-family: ${secondaryFont};
  font-weight: ${wMedium};
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.8px;
  text-align: center;
  color: ${primaryHeadingColor};
  .active {
    color: ${primaryColor};
  }
`;

const GroupNameMergePopup = function GroupNameMergePopup(props: Props) {
  const {
    visibleFlag, onCancel, onMerge, onSave, groupName,
  } = props;

  return (
    <GroupModalWrapper
      centered
      width={582}
      closeIcon={<div className="cross-icon-x"><CrossCircle /></div>}
      getContainer=""
      wrapClassName="popup"
      visible={visibleFlag}
      onCancel={onCancel}
      closable
    >
      <GroupNameHeading>
        The group name
        {' '}
        <span className="active">
          &rdquo;
          {groupName}
          &rdquo;
        </span>
        {' '}
        already exists.
      </GroupNameHeading>
      <GroupNameHeading>
        Do you want to?
      </GroupNameHeading>
      <div className="ant-modal-footer custom-footer">
        <button
          className="ant-btn ant-btn-default borderedButton"
          type="button"
          aria-label=""
          onClick={onMerge}
        >
          Merge
        </button>
        <button
          className="ant-btn ant-btn-default borderedButton filled-btn"
          type="button"
          aria-label=""
          onClick={onSave}
        >
          Save
        </button>
        <span className="copyGroupName">*  Clicking save, will copy the group name.</span>
      </div>
    </GroupModalWrapper>
  );
};

export default GroupNameMergePopup;
